(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mas-alla-landing"] && !Shopify.designMode) return;
  try {
    

  const maujInit = (scope = document) => {
    scope.querySelectorAll('[data-mauj-section]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const reviewTrack = section.querySelector('[data-readers-track]');
      if (reviewTrack) {
        const back = section.querySelector('[data-readers-prev]');
        const forward = section.querySelector('[data-readers-next]');
        const updateReviews = () => {
          back.disabled = reviewTrack.scrollLeft < 2;
          forward.disabled = reviewTrack.scrollLeft >= reviewTrack.scrollWidth - reviewTrack.clientWidth - 2;
        };
        [back, forward].forEach((button, index) => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const step = reviewTrack.children.length > 1 ? reviewTrack.children[1].offsetLeft - reviewTrack.children[0].offsetLeft : 0;
            reviewTrack.scrollBy({left: step * (index ? 1 : -1), behavior: reduced.matches ? 'auto' : 'smooth'});
          });
        });
        reviewTrack.addEventListener('scroll', updateReviews, {passive:true});
        new ResizeObserver(updateReviews).observe(reviewTrack);
        updateReviews();
      }
      const carousel = section.querySelector('[data-mauj-carousel]');
      const cards = carousel ? Array.from(carousel.children) : [];
      const prev = section.querySelector('[data-mauj-prev]');
      const next = section.querySelector('[data-mauj-next]');
      const position = section.querySelector('[data-carousel-position]');
      const progress = section.querySelector('[data-carousel-progress]');
      const refreshCarousel = () => {
        if (!carousel || !cards.length) return;
        const step = cards[0].getBoundingClientRect().width + 16;
        const max = carousel.scrollWidth - carousel.clientWidth;
        const current = Math.min(cards.length, Math.round(carousel.scrollLeft / step) + 1);
        if (prev) prev.disabled = carousel.scrollLeft < 2;
        if (next) next.disabled = carousel.scrollLeft >= max - 2;
        if (position) position.textContent = current + ' / ' + cards.length;
        if (progress) progress.style.setProperty('--carousel-progress', Math.max(20, (carousel.scrollLeft + carousel.clientWidth) / carousel.scrollWidth * 100) + '%');
      };
      const move = (direction) => {
        if (!carousel || !cards.length) return;
        carousel.scrollBy({ left: (cards[0].getBoundingClientRect().width + 16) * direction, behavior: reduced.matches ? 'auto' : 'smooth' });
      };
      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      carousel?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      carousel?.addEventListener('scroll', refreshCarousel, { passive: true });
      window.addEventListener('resize', refreshCarousel, { passive: true });
      refreshCarousel();
      const tabs = section.querySelector('[data-benefit-tabs]');
      if (tabs) {
        tabs.setAttribute('role', 'tablist');
        const buttons = Array.from(tabs.querySelectorAll('[data-benefit-button]'));
        const activate = (index, focus = false) => buttons.forEach((button, i) => {
          const active = i === index;
          button.setAttribute('aria-selected', String(active));
          button.removeAttribute('aria-expanded');
          button.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !active; panel.classList.toggle('is-active', active); }
          if (active && focus) button.focus();
        });
        buttons.forEach((button, index) => {
          button.id = 'tab-' + button.getAttribute('aria-controls');
          button.setAttribute('role', 'tab');
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (panel) { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', button.id); panel.tabIndex = 0; }
          button.addEventListener('click', () => activate(index));
          button.addEventListener('keydown', (event) => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft') target = (index - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = buttons.length - 1;
            if (target !== undefined) { event.preventDefault(); activate(target, true); }
          });
        });
        activate(0);
      }
      const motionButton = section.querySelector('[data-motion-toggle]');
      motionButton?.addEventListener('click', () => {
        const paused = section.classList.toggle('is-motion-paused');
        motionButton.setAttribute('aria-pressed', String(paused));
        motionButton.setAttribute('aria-label', paused ? 'Reanudar animaciones' : 'Pausar animaciones');
        motionButton.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      });
      const sticky = section.querySelector('[data-mauj-sticky]');
      const hero = section.querySelector('.mauj__purchase-row');
      const purchaseAreas = section.querySelectorAll('[data-mauj-checkout]');
      const navLinks = Array.from(section.querySelectorAll('.mauj__section-nav a'));
      const targets = navLinks.map(a => { const href=a.getAttribute('href'); return href?.startsWith('#') ? document.getElementById(href.slice(1)) : null; });
      let scheduled = false;
      const update = () => {
        scheduled = false;
        if (!section.isConnected) return;
        const otherPurchaseVisible = Array.from(purchaseAreas).some(area => { if (area.closest('.mauj__sticky')) return false; const b = area.getBoundingClientRect(); return b.height > 0 && b.top < innerHeight - 80 && b.bottom > 0; });
        if (sticky && hero) {
          const visible = hero.getBoundingClientRect().bottom < 0 && !otherPurchaseVisible;
          sticky.classList.toggle('is-visible', visible);
          sticky.inert = !visible;
        }
        let active = -1;
        targets.forEach((target,index) => { if (target && target.getBoundingClientRect().top < 200) active = index; });
        navLinks.forEach((link,index) => { link.classList.toggle('is-current', index === active); if (index === active) link.setAttribute('aria-current','location'); else link.removeAttribute('aria-current'); });
      };
      const onScroll = () => { if (!scheduled && section.isConnected) { scheduled = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
      if ('IntersectionObserver' in window && !reduced.matches) {
        const observer = new IntersectionObserver((entries) => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
        }), { threshold: .05, rootMargin: '0px 0px 0px 0px' });
        const targets = section.querySelectorAll('.mauj-heading, .mauj__question, .mauj__story-image, .mauj__benefit-copy, .mauj__book-wrap, .mauj__included > div:last-child, .mauj__chapter-head, .mauj__author > *, .mauj__offer-card, .mauj__steps li, .mauj__faq > *');
        targets.forEach((item,index) => { item.classList.add('mauj-reveal'); item.style.setProperty('--mauj-delay', ((index % 3) * 60) + 'ms'); observer.observe(item); });
      }
    });
  };
  maujInit();
  document.addEventListener('shopify:section:load', (event) => maujInit(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mauj-pages"] && !Shopify.designMode) return;
  try {
    
  const mjPageInit = (root = document) => {
    root.querySelectorAll('[data-mj-page="home"]').forEach(page => {
      if (page.dataset.motionReady) return;
      page.dataset.motionReady = 'true';

      const purchaseBar = page.querySelector('[data-home-purchase]');
      const heroBuy = page.querySelector('.mj-hero__copy > .mj-button');
      let purchaseTick = false;
      const updatePurchase = () => {
        purchaseTick = false;
        if (!page.isConnected || !purchaseBar || !heroBuy) return;
        const otherVisible = Array.from(page.querySelectorAll('[data-mauj-checkout]')).some(a => {
          if (a.closest('[data-home-purchase]')) return false;
          const r = a.getBoundingClientRect();
          return r.height > 0 && r.top < innerHeight - 75 && r.bottom > 0;
        });
        const show = heroBuy.getBoundingClientRect().bottom < 0 && !otherVisible;
        purchaseBar.classList.toggle('is-visible', show);
        purchaseBar.inert = !show;
      };
      window.addEventListener('scroll', () => {if (!purchaseTick) {purchaseTick=true;requestAnimationFrame(updatePurchase);}}, {passive:true});
      window.addEventListener('resize', updatePurchase);
      updatePurchase();
      const toggle = page.querySelector('[data-mj-motion]');
      toggle?.addEventListener('click', () => {
        const paused = page.classList.toggle('is-motion-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        toggle.setAttribute('aria-label', paused ? 'Reanudar animaciones' : 'Pausar animaciones');
        toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      });
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible'); observer.unobserve(entry.target);
      }), { threshold:.05 });
      page.querySelectorAll('.mj-cards article, .mj-discover__grid > *, .mj-authors > *, .mj-steps li, .mj-final h2').forEach((el,index) => {
        el.classList.add('mj-appear'); el.style.setProperty('--delay', ((index % 3) * 70) + 'ms'); observer.observe(el);
      });
    });
  };
  mjPageInit();
  document.addEventListener('shopify:section:load', event => mjPageInit(event.target));

  } catch(e) { console.error(e); }
})();
})();
